import React, { ReactNode } from 'react'
import { createIntl, createIntlCache, IntlProvider } from 'react-intl'
import queryString from 'query-string'
import { pl, enGB, de } from 'date-fns/locale'

export const supportedLocales = ['pl', 'en', 'de']

type SupportedLocale = typeof supportedLocales[number]

const localeToFns: { [P in SupportedLocale]: typeof pl } = {
  pl: pl,
  en: enGB,
  de: de,
}

const checkTranslated = false

const messages: {
  [key: string]: {
    [key: string]: string
  }
} = {}

for (var locale of supportedLocales) {
  messages[locale] = require('../../lang/' + locale + '.json')
}

const getLocale = (locale: string) => {
  return supportedLocales.includes(locale) ? locale : false
}

const browserLocale = getLocale(navigator.language.substr(0, 2))

const params = queryString.parse(window.location.search)
const paramLocale = params.lang
  ? getLocale((params.lang as string).toLowerCase())
  : false

type Props = {
  locale?: string
  children: ReactNode
  addToWindow?: boolean
}

const LanguageContainer: React.FC<Props> = ({
  children,
  locale = '',
  addToWindow = false,
}) => {
  let selectedLocale = locale || paramLocale || browserLocale || 'en'

  const suppSelLocale = selectedLocale as SupportedLocale

  const cache = createIntlCache()

  const fallbackedMessages = Object.keys(messages[suppSelLocale]).reduce(
    (prev, key) => {
      prev[key] = messages[suppSelLocale][key].length
        ? messages[suppSelLocale][key]
        : messages['en'][key]

      // checkTranslated && (prev[key] = 'translated')
      checkTranslated && (prev[key] = '+' + messages['en'][key])

      return prev
    },
    {}
  )

  window.localeFns = localeToFns[suppSelLocale]

  if (addToWindow) {
    window.intl = createIntl(
      {
        locale: suppSelLocale,
        messages: fallbackedMessages,
      },
      cache
    )
  }

  return (
    <IntlProvider
      messages={fallbackedMessages}
      locale={suppSelLocale}
      defaultLocale="en"
    >
      {children}
    </IntlProvider>
  )
}

export default LanguageContainer
